<!-- Referral Button -->
@if (canSeeReferralButton) {
  <button
    class="menu-button has-icon"
    mat-menu-item
    (click)="referAFriendClicked()"
  >
    <emperor-icon name="bp_user_share"></emperor-icon>
    <span class="mat-label-large">Refer a friend!</span>
  </button>
}
<!-- Logout Button -->
<button
  class="menu-button has-icon logout-button"
  mat-menu-item
  (click)="logoutClicked()"
>
  <emperor-icon name="bp_logout"></emperor-icon>
  <span class="mat-label-large">Log Out</span>
</button>
